// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__28ziW","label":"LabeledBox_label__2mmuu"};